/**
 * Created by georgehupeijie on 2018/5/28.
 */
import Polling from './src/polling.js';

export default Polling;
